/**
 * Accountability API Client
 */

import apiClient from './client';

export interface UserStats {
  assignee_id: string;
  user_name: string | null;
  user_email: string | null;
  total: number;
  completed: number;
  completed_late: number;
  overdue: number;
  pending: number;
  in_progress: number;
}

export interface AccountabilitySummary {
  total_tasks: number;
  total_completed: number;
  total_overdue: number;
  total_on_time: number;
}

export interface AccountabilityResponse {
  items: UserStats[];
  summary: AccountabilitySummary;
  start_date: string;
  end_date: string;
}

export interface UserTask {
  id: string;
  title: string;
  state: string;
  due_date: string;
  completed_at: string | null;
  created_at: string;
  template_name: string | null;
  is_late: boolean;
  is_overdue: boolean;
}

export interface UserTasksResponse {
  items: UserTask[];
  total: number;
  page: number;
  limit: number;
}

export const accountabilityApi = {
  async getStats(startDate: string, endDate: string, userId?: string): Promise<AccountabilityResponse> {
    const params: Record<string, string> = { start_date: startDate, end_date: endDate };
    if (userId) params.user_id = userId;
    const { data } = await apiClient.get('/v1/activity-logs/accountability', { params });
    return data;
  },

  async getUserTasks(userId: string, startDate: string, endDate: string, page = 1): Promise<UserTasksResponse> {
    const { data } = await apiClient.get(`/v1/activity-logs/accountability/${userId}/tasks`, {
      params: { start_date: startDate, end_date: endDate, page: String(page) },
    });
    return data;
  },
};
